import { cn } from "@/shared/lib/cn";

/**
 * The Any AI mark — an ink rounded-square holding the lowercase "a." wordmark
 * glyph (the same logo as the landing site's favicon). Fills resolve to tokens
 * (ink square, canvas glyph) so the mark inverts cleanly in dark mode. Used
 * standalone (sidebar + auth brand) and as the assistant / fallback avatar.
 */
export interface BrandMarkProps {
  /** Square size in px. Default 30 (sidebar brand). */
  size?: number;
  className?: string;
}

export function BrandMark({ size = 30, className }: BrandMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 180 180"
      aria-hidden="true"
      className={cn("block shrink-0", className)}
    >
      <rect width="180" height="180" rx="40" ry="40" className="fill-ink" />
      <g className="fill-canvas">
        <path transform="translate(37.6380 128.0160) scale(0.144 -0.144)" d="M186 -14Q142 -14 108.0 3.5Q74 21 55.0 54.5Q36 88 36 136Q36 181 53.5 210.5Q71 240 104.5 257.5Q138 275 185.0 286.5Q232 298 292 307Q321 312 340.5 316.5Q360 321 370.0 331.0Q380 341 380 360Q380 385 362.0 403.0Q344 421 304 421Q276 421 253.5 411.0Q231 401 215.0 382.0Q199 363 191 336L49 378Q62 420 85.5 451.0Q109 482 142.0 502.5Q175 523 217.5 532.5Q260 542 308 542Q388 542 438.5 516.5Q489 491 513.5 437.5Q538 384 538 300V219Q538 183 539.5 146.5Q541 110 543.5 73.5Q546 37 550 0H408Q404 23 400.0 55.5Q396 88 394 122H375Q361 84 334.5 52.5Q308 21 270.5 3.5Q233 -14 186 -14ZM259 100Q277 100 295.5 106.5Q314 113 331.0 124.5Q348 136 362.0 153.0Q376 170 383 190L381 269L403 264Q384 252 361.0 245.0Q338 238 314.5 234.0Q291 230 268.5 225.5Q246 221 228.5 214.0Q211 207 201.0 195.0Q191 183 191 162Q191 134 210.0 117.0Q229 100 259 100Z" />
        <path transform="translate(117.5580 128.0160) scale(0.144 -0.144)" d="M125 -13Q73 -13 47.5 9.0Q22 31 22 77Q22 124 47.5 146.0Q73 168 125 168Q178 168 204.0 146.0Q230 124 230 77Q230 -13 125 -13Z" />
      </g>
    </svg>
  );
}
